import * as React from "react";
// Shared components
import Info from "./components/Info";
import Modal from "components/Modal";
import StepBtn from "components/Button";
//Local component
import { Button, Typography } from "antd";
// Utilities and hooks
import addCommas from "helpers/index";
import useWallet from "hooks/useWallet";
import { useSell } from "../..";
import useUser from "hooks/useUser";
import { inject, observer } from "mobx-react";
import UserStore from "state/user";
import jMoment from "moment-jalaali";
// Styles
import styles from "./index.module.scss";

interface IProps {
	user?: UserStore | any;
}

const { Paragraph } = Typography;

const SecondComponent: React.FC<IProps> = props => {
	const { cancelStock } = useWallet();
	const { dispatch, state } = useSell();
	const { getUserInfo, getAssetsInfo } = useUser();
	const [showModal, setShowModal] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const [pricingChange, setPricingChange] = React.useState({ newPrice: 0, oldPrice: 0 });
	const sellPrice = React.useMemo(() => props.user.goldSellPrice, [props.user.goldSellPrice]);

	async function payment() {
		try {
			setLoading(true);
			const result = await cancelStock({
				// @ts-ignore
				amount: state.unit,
				baseBaazarAmount: sellPrice,
			});

			if (result.status === "DONE") {
				await getUserInfo();
				dispatch({ current: 2 });
				setLoading(false);
			} else if (result.status === "PRICE_CHANGED") {
				setPricingChange({
					newPrice: result.newPrice,
					oldPrice: result.oldPrice,
				});
				setLoading(false);
				await getAssetsInfo();
				setShowModal(true);
			}
		} catch (error) {
			setLoading(false);
			throw error;
		}
	}

	function handleCancel() {
		setShowModal(false);
	}

	function previous() {
		dispatch({ ...state, current: 0 });
	}

	return (
		<div className={styles["main"]}>
			<h3 className={styles["main__title"]}>اطلاعات درخواست فروش طلا</h3>
			<div className={styles["main__table"]}>
				<Info
					prefix="گرم"
					title="مقدار طلای درخواستی"
					info={state.unit ? state.unit : Number(state.amount) / sellPrice}
				/>
				<Info
					prefix="ریال"
					title="مبلغ قابل دریافت"
					info={addCommas(state.amount ? Number(state.amount) : Number(state.unit) * sellPrice)}
				/>
				<Info title="تاریخ درخواست " info={jMoment().format("jYYYY/jMM/jDD")} />
				<Info title="قیمت فروش هر گرم طلا در سامانه" prefix="ریال" info={addCommas(sellPrice)} />
			</div>

			<StepBtn onClick={payment} loading={loading} green>
				تایید نهایی و فروش طلا
			</StepBtn>
			<StepBtn onClick={previous} primary>
				بازگشت
			</StepBtn>

			<Modal
				visible={showModal}
				title="اطلاع"
				onCancel={handleCancel}
				footer={[
					<Button key="back" type="primary" onClick={handleCancel}>
						لغو
					</Button>,
					<Button key="submit" type="primary" loading={loading} onClick={payment}>
						فروش
					</Button>,
				]}
			>
				<Paragraph>
					قیمت هر گرم طلا از &nbsp;<b>{addCommas(pricingChange.oldPrice)}</b>&nbsp; به &nbsp;
					<b>{addCommas(pricingChange.newPrice)}</b>
				</Paragraph>
				<Paragraph>آیا مایل به فروش به این قیمت هستید؟</Paragraph>
			</Modal>
		</div>
	);
};

export default inject("user")(observer(SecondComponent));
